// errors
export default {
    getErrorMessage(state) {
        return state.errorMessage
    },

    getErrorIcon(state) {
        return state.errorIcon
    },

    getErrorCallback(state) {
        return state.errorCallback;
    }
}
